<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<h1 class="CN sink">I</h1>
<h1 class="chaptertitle parttitle">FROM NORTHEAST TO NORTHWEST: THE DOURO AND THE DUERO</h1>
<a id="p2"></a>
<figure class="full breakboth ">
<img alt=" " id="fig_JourneyToPortugal-3" src="images/JourneyToPortugal-3.jpg"/>
</figure>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c001.vue?beabbb08